import React from 'react'

import { useDeviceSize } from 'utils/hooks/useDeviceSize'
import { openLink } from 'utils/html/window'

import Button from 'components/Button'

import styles from './styles.module.scss'

const PdfViewer = ({ src, ...rest }) => {
  const { isSmallOnlyScreen } = useDeviceSize()

  const openInNewTab = () =>
    openLink({
      url: src,
      newTab: true,
      isExternalLink: true
    })

  if (isSmallOnlyScreen) {
    return (
      <div className={styles.pdfViewerWrapperMobile} {...rest}>
        <Button variant="secondary" onClick={openInNewTab}>
          Click here to view PDF
        </Button>
      </div>
    )
  }

  return (
    <div className={styles.pdfViewerWrapper} {...rest}>
      {/* An iframe rather than <object>: Safari treats <object> as a plugin
          element and renders a blank box for cross-origin PDFs. */}
      <iframe
        className={styles.pdfViewer}
        src={src}
        title="PDF document"
      />
      <div className={styles.pdfViewerFallback}>
        <span className="text-gray-dark mr-10">
          Trouble viewing the PDF?
        </span>
        <Button
          variant="secondary"
          smallPadding
          onClick={openInNewTab}
        >
          Open in new tab
        </Button>
      </div>
    </div>
  )
}

export default PdfViewer
